import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the notificationContainer state domain
 */

const selectNotificationContainerDomain = (state) =>
  state.get("notificationContainer", initialState)

/**
 * Other specific selectors
 */

/**
 * Default selector used by NotificationContainer
 */

export const MakeSelectCount = () =>
  createSelector(selectNotificationContainerDomain, (state) =>
    state.get("count")
  )

export const MakeSelectTotal = () =>
  createSelector(selectNotificationContainerDomain, (state) =>
    state.get("total")
  )

export const MakeSelectNotifications = () =>
  createSelector(selectNotificationContainerDomain, (state) =>
    state.get("notifications")
  )

export const MakeSelectIsLoading = () =>
  createSelector(selectNotificationContainerDomain, (state) =>
    state.get("isLoading")
  )

const makeSelectNotificationContainer = () =>
  createSelector(selectNotificationContainerDomain, (substate) =>
    substate.toJS()
  )

export default makeSelectNotificationContainer
export { selectNotificationContainerDomain }
